import { SIGN_IN, PARTNER_LIST, GET_PARTNER } from '../../types/types';
import { ILoginUser } from '../../models/login.interface'; 

export const signIn = (user: ILoginUser) => {
  const { route, userId, name, status, accessLevel, accessType, accessList } = user;
  return {
    type: SIGN_IN,
    payload: {
      route,
      userId,
      name,
      status,
      accessLevel,
      accessType,
      accessList
    }
  };
};

export const partnerList = (partnerList: string) => {
  return {
    type: PARTNER_LIST,
    payload: partnerList
  };
};

export const fetchUser = () => {
  return function(dispatch: any, getState: any) {
    const state = getState();
    
    return {
      type: GET_PARTNER,
      payload: state
    }
  }
};
